import { createSlice } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';
import { LoanStatusApi, LoanStatusApi_extrareducer } from './loan-status';

const initialState = {
  loanStatusApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
};

export const LoanStatusSlice = createSlice({
  name: 'loanStatus',
  initialState,
  extraReducers: {
    ...LoanStatusApi_extrareducer,
  },
});

export function useLoanStatusStore() {
  const loanStatusApiState = useSelector(
    (state) => state.loanStatus.loanStatusApiState
  );

  const dispatch = useDispatch();

  return {
    loanStatusApiState,
    LoanStatusApi: (payload) => dispatch(LoanStatusApi(payload)),
  };
}

export default LoanStatusSlice.reducer;
